const initialState = {
    enabled: false,
    header: '',
    body: '',
    callback: null
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL':
        return {
            ...state,
            enabled: true,
            header: action.header,
            body: action.body,
            callback: action.callback
        };
        case 'CLOSE_MODAL':
        return {
            ...state,
            enabled: false,
        };
        default:
        return state;
    }
};

export default modalReducer;